import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'Úvod', path: '/' },
    { name: 'Využití', path: '/vyuziti' },
    { name: 'Jak začít', path: '/jak-zacit' },
    { name: 'Podpora', path: '/podpora' },
    { name: 'Ceník', path: '/cenik' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-[color:var(--border)] bg-white/90 backdrop-blur-lg shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_smartedu-ai-4/artifacts/2da2chy6_skolobotlogo.png" 
                alt="Školobot Logo" 
                className="h-10 w-auto"
              />
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-sm font-medium text-[color:var(--text-secondary)] hover:text-[color:var(--primary-500)] transition-colors"
              >
                {link.name}
              </Link>
            ))}
            <a href="https://app.skolobot.cz/register" target="_blank" rel="noopener noreferrer">
              <Button className="bg-[color:var(--primary-500)] hover:bg-[color:var(--primary-600)] text-white rounded-xl shadow-md">
                Objednat licenci
              </Button>
            </a>
            <a href="https://app.skolobot.cz/login" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-2 border-[color:var(--primary-500)] text-[color:var(--primary-600)] hover:bg-[color:var(--primary-50)] rounded-xl">
                Přihlásit se
              </Button>
            </a>
          </div>

          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[280px] bg-white">
                <div className="flex flex-col gap-6 mt-8">
                  {navLinks.map((link) => (
                    <Link key={link.name} to={link.path} onClick={() => setIsOpen(false)} className="text-lg font-medium text-[color:var(--text-secondary)]">
                      {link.name}
                    </Link>
                  ))}
                  <div className="flex flex-col gap-3">
                    <a href="https://app.skolobot.cz/register" target="_blank" rel="noopener noreferrer">
                      <Button className="bg-[color:var(--primary-500)] text-white w-full rounded-xl">Objednat licenci</Button>
                    </a>
                    <a href="https://app.skolobot.cz/login" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline" className="border-2 border-[color:var(--primary-500)] text-[color:var(--primary-600)] w-full rounded-xl">Přihlásit se</Button>
                    </a>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;